import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, ListMethodArg, ListMethodResponse, GetMethodResponse, ModelClass, References } from '/imports/types';

export interface CardSource extends Doc {
  _id: string;
  windowsroot: string;
  clientpath: string;
}

type Model = CardSource;
type Refs = References<Model>;

export const CardSources = new Mongo.Collection<CardSource>('cardSources');

export const listCardSources = DeclareMethod<ListMethodArg<CardSource>, ListMethodResponse<CardSource, Refs>>('listCardSources');
export const getCardSource = DeclareMethod<string, GetMethodResponse<CardSource, Refs>>('getCardSource');
export const createCardSource = DeclareMethod<Partial<CardSource>, string>('createCardSource');
export const updateCardSource = DeclareMethod<Partial<CardSource>, string>('updateCardSource');
export const deleteCardSource = DeclareMethod<string, undefined>('deleteCardSource');

export const modelClass: ModelClass<Model, Refs> = {
  collection: CardSources,
  editableFields: ['windowsroot', 'clientpath'],
  listMethod: listCardSources,
  getMethod: getCardSource,
  createMethod: createCardSource,
  updateMethod: updateCardSource,
  deleteMethod: deleteCardSource,
  pathPrefix: '/card-sources',
  modelName: 'Card Source',
  pluralName: 'Card Sources',
};
